import HoverSliderHero from '@/components/landing/HoverSliderHero';
import { useReferralTracking } from '@/hooks/useReferralTracking';
import { SEOHead } from '@/hooks/useSEO';
import { getOrganizationSchema } from '@/utils/structuredData';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Landing() {
  useReferralTracking();
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Turn Kids' Drawings into Real 3D Toys"
        description="Transform your child's artwork into a custom 3D-printed toy. AI-powered design, child-safe materials, delivered in 14 days."
        structuredData={getOrganizationSchema()}
        language={language}
      />
      <HoverSliderHero />
    </div>
  );
}
